






































































































import { Vue, Component } from "vue-property-decorator";
@Component
export default class HeaderNotice extends Vue
{
    /**
     * loading
     * @wrapperCol
     * @type {boolean}
    */
    protected loading: boolean = false;

    /**
     * visible
     * @wrapperCol
     * @type {boolean}
    */
    protected visible: boolean = false;

    /**
     * 更新通知
     * @protected
     * @return void
     */
    protected fetchNotice(): void
    {
        if (!this.visible)
        {
            this.loading = true;
            setTimeout(() => {
                this.loading = false
            }, 100);
        }
        else
        {
            this.loading = false;
        }
        this.visible = !this.visible;
    }
}
